const SlaConfigurationConstants = {
  // Types of Slas
  type: [{
    id: 1,
    from: 'ARRIVAL',
    to: 'CUTOFF',
    name: 'ARRIVAL_CUTOFF',
  },
  {
    id: 2,
    from: 'INDENT_INDENT',
    to: 'CUTOFF',
    name: 'INDENT_CUTOFF',
  },
  {
    id: 3,
    from: 'INDENT_INDENT',
    to: 'AUTO CANCELLATION',
    name: 'INDENT_AUTO_CANCEL',
  },
  {
    id: 4,
    from: 'INDENT_INDENT',
    to: 'ACCEPTANCE',
    name: 'INDENT_ACCEPTANCE',
  },
  {
    id: 5,
    from: 'ADMIN_DEPOT',
    to: 'WORKING HOURS',
    name: 'DEPOT_WORKING_HOURS',
  },
  {
    id: 6,
    from: 'REINDENT',
    to: 'ACCEPTANCE',
    name: 'REINDENT_ACCEPTANCE',
    feature: 'reindent_acceptance',
  },
  {
    id: 7,
    from: 'REINDENT',
    to: 'ARRIVAL',
    name: 'REINDENT_ARRIVAL',
    feature: 'reindent_arrival',
  }],
  slaTypeIdMap: {
    ARRIVAL_CUTOFF: 1,
    INDENT_CUTOFF: 2,
    INDENT_AUTO_CANCEL: 3,
    INDENT_ACCEPTANCE: 4,
    DEPOT_WORKING_HOURS: 5,
    REINDENT_ACCEPTANCE: 6,
    REINDENT_ARRIVAL_CUTOFF: 7, 
  },
  // Current sla active from the above list
  allowedTypes: [1, 2, 3, 4, 5, 6, 7],
  defaultValue: {
    slas: [
      { sla_type: 3, duration: 511200000 },
      { sla_type: 2, duration: 43200000 },
      { sla_type: 1, duration: 63000000 },
    ],
  },
  getDefaultValue: {
    slas: [
      { sla_type: 5, start_duration: 0, end_duration: 0 },
      { is_sla_enabled : true, sla_type: 4, duration: 7200000 },
      { sla_type: 3, duration: 511200000 },
      { sla_type: 2, duration: 43200000 },
      { is_sla_enabled : true, sla_type: 1, duration: 86400000 },
    ],
  },
};

module.exports = { SlaConfigurationConstants };
